import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { AppContext } from '../AppContext';
import {
  trackSessionStart,
  trackPageView,
  setTrackingUser,
} from '../lib/tracking';

// Инициализирует трекинг: session_start один раз, page_view на смену роута,
// и подвязывает userId/accountId из текущей сессии.
export function useTracking(): void {
  const location = useLocation();
  const appContext = useContext(AppContext);
  const initialized = useRef(false);
  const previousPath = useRef<string | null>(null);

  // userId/accountId из сессии
  useEffect(() => {
    setTrackingUser(appContext?.session?.userId, appContext?.session?.accountId);
  }, [appContext?.session?.userId, appContext?.session?.accountId]);

  // session_start
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!initialized.current) {
      initialized.current = true;
      trackSessionStart();
    }
  }, []);

  // page_view
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const currentPath = location.pathname;
    if (previousPath.current === currentPath) return;
    const referrer = previousPath.current
      ? `${window.location.origin}${previousPath.current}`
      : undefined;
    trackPageView(currentPath, referrer);
    previousPath.current = currentPath;
  }, [location.pathname]);
}

export default useTracking;
